import React from 'react';

// Same spinner as the BEST Tools login callback, so the handoff looks like one loader
const LoadingState = () => (
  <div className="bt-loading-page" role="status" aria-label="Loading">
    <div className="bt-spinner" />
  </div>
);

const ErrorState = ({ error }) => (
  <div className="App">
    <h1>SMA Scheduler</h1>
    <p>Error loading data: {error}</p>
    <p>Please make sure the backend server is running. </p>
  </div>
);

export { LoadingState, ErrorState };